import React from 'react';
import { Icon } from '@/presentation/components';
import { Container } from './style';

export const ButttonDS = ({ name, onClick }: any) => (
  <Container
    type="button"
    onClick={(e) => onClick(e)}
    data-testid="cmd-see-more"
  >
    <Icon name="chevron-down" size={24} />
    <p>{name}</p>
  </Container>
);

export const ButttonDSCustom = ({
  name,
  onClick,
  icon,
  iconAfter = false,
  iconBefore = false
}: any) => (
  <Container
    onClick={(e) => onClick(e)}
    data-testid="cmp-btn-ds-custom"
    style={{ padding: '10px 8px' }}
  >
    {iconBefore && <Icon name={icon} size={24} />}
    <p>{name}</p>
    {iconAfter && <Icon name={icon} size={24} />}
  </Container>
);
